// components/cells/CellInfoTooltip.tsx
import { Box, Tooltip, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/InfoOutlined';

interface CellInfoTooltipProps {
  value: string | number;
  tooltipText: string;
}

const CellInfoTooltip = ({ value, tooltipText }: CellInfoTooltipProps) => (
  <Box display="flex" alignItems="center" gap={0.5}>
    <Typography variant="body2">{value}</Typography>
    <Tooltip title={tooltipText}>
      <InfoIcon fontSize="small" color="action" sx={{ cursor: 'pointer' }} />
    </Tooltip>
  </Box>
);

export default CellInfoTooltip;
